<template>
  <iframe :src="srcUrl" style="width: 100%;height: 100%;">

  </iframe>
</template>

<script setup>
/*
 * 支持同时打开多个文档的预览组件。
 *
 * 可能多个同时预览的 ---调用这个。
 */

const srcUrl = ref('')

const props = defineProps({
  fileUrl: {
    type: String,
    required: true,
  }
})

onMounted(() => {
  srcUrl.value = `/learning/aliIOfficeRouter?fileUrl=${encodeURIComponent(props.fileUrl)}`
})


</script>

<style scoped lang="scss">

</style>
